
    const isAdmin = window.location.pathname.startsWith("/admin");

    if (!isAdmin) {
      // normal site: load React entry
      import("/index.tsx");
    } else {
      // admin: remove React root (not used here)
      const root = document.getElementById("root");
      if (root) {
        root.remove();
      }

      // make sure there is an nc-root container
      let ncRoot = document.getElementById("nc-root");
      if (!ncRoot) {
        ncRoot = document.createElement("div");
        ncRoot.id = "nc-root";
        document.body.appendChild(ncRoot);
      }

      // load Decap CMS script from CDN
      const script = document.createElement("script");
      script.src = "https://unpkg.com/decap-cms@^3.0.0/dist/decap-cms.js";
      document.body.appendChild(script);
    }
  